import { distanceAndSkiddingToXY } from "@popperjs/core/lib/modifiers/offset";
import classNames from "classnames";
import React, { ReactNode, useState } from "react";
import { Collapse, Fade } from "react-bootstrap";
import SvgChevronRight from "../icons/ChevronRight";
import * as bd from "../index";

interface PanelProps {
    variant?: "text" | "button" | "menu";
    className?: string;
    title?: ReactNode;
    headerClassName?: string;
    titleClassName?: string;
    caretPosition?: "" | "start" | "middle" | "end";
    size?: "" | "sm" | "md" | "lg";
    fixed?: boolean;
    expanded?: boolean;
    disabled?: boolean;
    controls?: any;
    lazyload?: boolean;
    onToggle: (expanded: boolean) => void;
    children?: any;
    [x: string]: any;
}

export const Panel = ({
    variant,
    className,
    title,
    headerClassName,
    titleClassName,
    caretPosition,
    size,
    fixed,
    expanded,
    disabled,
    controls,
    lazyload,
    onToggle,
    children,
    ...props
}: PanelProps) => {
    const [panelState, setPanelState] = useState({ isExpanded: expanded, render: expanded || !lazyload });

    const cn = classNames("bd-panel", className, {
        "bd-panel-menu": variant === "menu",
    });

    const toggle = (caret) => {
        var just_caret = variant !== "button" && variant !== "menu";
        if ((caret && !just_caret) || (!caret && just_caret)) return null;
        if (disabled || fixed) return;
        const isExpanded = !panelState.isExpanded;
        setPanelState({ isExpanded, render: true });
        if (onToggle) onToggle(isExpanded);
    };

    function renderHandler(position) {
        var show = (!caretPosition && position === "start") || caretPosition === position;
        if (fixed || !children || !show) return null;
        return (
            <span
                className={classNames("px-2 py-1", {
                    "cur-pointer": !disabled,
                    "edge-start": position === "start",
                    "edge-end": position === "end",
                })}
                onClick={() => toggle(true)}
            >
                <SvgChevronRight
                    className={classNames("transition-transform", {
                        "rotate-90": panelState.isExpanded,
                        "rtl-rotate-180": !panelState.isExpanded,
                    })}
                />
            </span>
        );
    }

    return (
        <div className={cn} {...props}>
            <bd.Toolbar
                size={size}
                onClick={() => toggle(false)}
                className={classNames(headerClassName, {
                    "cur-pointer": variant === "button" || variant === "menu",
                    disabled: disabled,
                })}
            >
                {renderHandler("start")}
                <h5 className={classNames("d-flex", titleClassName, { "flex-grow-1": caretPosition !== "middle" })}>{title}</h5>

                {renderHandler("middle")}

                {controls != null && <div className="m-s-auto"></div>}
                {controls}
                {renderHandler("end")}
            </bd.Toolbar>

            {children && (
                <Collapse in={panelState.isExpanded}>
                    <div>{panelState.render && children}</div>
                </Collapse>
            )}
        </div>
    );
};
